import React from "react";

function Traduzione(props) {
    const utente = props.utente;
    const prodottoTemp = props.prodottoTemp;
    const traduci = props.traduci;
    const buttonClassesWhite = props.buttonClassesWhite;

    return (
        <div>
            {utente.permessiAPI["usage:googleapis"]
                && prodottoTemp._id
                /* && prodottoTemp.tradotto.en === false
                && prodottoTemp.tradotto.fr === false */
                && <div>
                    <button
                        onClick={traduci}
                        className={buttonClassesWhite}
                    >Traduci questo prodotto</button>
                    <small>Attenzione: salvare prima il prodotto. La traduzione avviene sul doc presente in db</small>
                </div>}
                <p>MEMO - aggiungi possibilità di riciclare (inserire ricerca come in reference nei tools)</p>
        </div>
    )



}

export default Traduzione;